<template>
  <div class="video-lectures">
    <div class="section">
      <div class="section__wrapper">
        <div class="video-lectures__menu row" v-if="course">
          <div class="video-lectures__menu-title col-md-8">
            {{ course.title }}
          </div>
          <div class="col-md-4 p-0">
            <div class="video-lectures__modules-select">
              <v-select :searchable="false" :clearable="false" id="course" :loading="!course.modules.length" :disabled="!course.modules.length" label="title" name="course" :options="course.modules" v-model="module">
                <template slot="selected-option" slot-scope="module">
                  <span class="selected-type">Модуль {{module.index}}</span>
                </template>
                <template slot="option" slot-scope="module">
                  <span class="selected-type">Модуль {{module.index}}:</span>
                  <div>{{ module.title }}</div>
                  <div class="text-grey">
                    <span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.4678 8.39453L8.46555 8.39636L8.46341 8.39844L8.4678 8.39453ZM18.4219 8.208C18.3523 8.14095 18.2751 8.08228 18.1919 8.03319C18.0741 7.96385 17.9433 7.91942 17.8076 7.90263C17.672 7.88585 17.5343 7.89707 17.4031 7.9356C17.272 7.97414 17.1501 8.03916 17.0451 8.12667C16.9401 8.21417 16.8541 8.32229 16.7925 8.44433C16.448 9.12302 15.9729 9.72702 15.3945 10.2217C15.483 9.72328 15.5276 9.21808 15.5278 8.7119C15.5297 7.172 15.1234 5.65911 14.3505 4.32726C13.5775 2.99542 12.4654 1.89219 11.1274 1.1299C10.98 1.04635 10.8138 1.00161 10.6444 0.999886C10.475 0.998162 10.3079 1.03951 10.1588 1.12004C10.0098 1.20058 9.88362 1.31766 9.7922 1.46031C9.70078 1.60296 9.6471 1.76649 9.6362 1.93557C9.58024 2.88374 9.33236 3.81069 8.90759 4.66024C8.48282 5.50979 7.88999 6.26426 7.16503 6.87793L6.93456 7.06543C6.17648 7.57552 5.50546 8.20433 4.94726 8.92773C4.07958 10.0208 3.47851 11.3011 3.19172 12.6669C2.90493 14.0327 2.94031 15.4466 3.29506 16.7964C3.6498 18.1462 4.31415 19.3948 5.23543 20.4431C6.1567 21.4914 7.30956 22.3107 8.60257 22.8359C8.75439 22.898 8.91914 22.9217 9.08229 22.905C9.24545 22.8883 9.40198 22.8317 9.5381 22.7403C9.67422 22.6488 9.78573 22.5252 9.8628 22.3804C9.93987 22.2357 9.98013 22.0742 9.98003 21.9102C9.97932 21.8041 9.96252 21.6987 9.93023 21.5977C9.7065 20.7567 9.64208 19.8813 9.74028 19.0166C10.6865 20.8013 12.2054 22.216 14.0528 23.0332C14.2783 23.1341 14.5332 23.1477 14.7681 23.0713C16.2277 22.6002 17.5425 21.7637 18.5878 20.6413C19.633 19.519 20.3739 18.148 20.74 16.6586C21.1061 15.1692 21.0853 13.611 20.6796 12.1319C20.2739 10.6529 19.4967 9.3021 18.4219 8.208ZM14.5171 21.0391C13.6454 20.5973 12.8765 19.977 12.2603 19.2185C11.6441 18.4601 11.1944 17.5804 10.9405 16.6367C10.8629 16.319 10.8029 15.9972 10.7608 15.6729C10.7322 15.4663 10.6398 15.2738 10.4965 15.1224C10.3532 14.9709 10.1661 14.868 9.96146 14.8281C9.89841 14.8157 9.8343 14.8095 9.77003 14.8096C9.59427 14.8095 9.42161 14.8558 9.26944 14.9437C9.11728 15.0317 8.991 15.1582 8.90333 15.3106C8.0736 16.7417 7.65633 18.3746 7.69776 20.0283C6.968 19.4609 6.35811 18.7544 5.90344 17.9495C5.44876 17.1447 5.15835 16.2576 5.04903 15.3397C4.93971 14.4218 5.01366 13.4914 5.26658 12.6023C5.51951 11.7132 5.94639 10.8831 6.52247 10.1602C6.95989 9.59202 7.48756 9.09947 8.08447 8.70218C8.11032 8.6855 8.1351 8.66723 8.15869 8.64749C8.15869 8.64749 8.45538 8.40201 8.46552 8.39639C9.89022 7.19135 10.9035 5.5719 11.3643 3.7637C12.4538 4.77093 13.1804 6.10973 13.431 7.57221C13.6817 9.03469 13.4425 10.539 12.7505 11.8516C12.6591 12.0267 12.6216 12.225 12.6427 12.4215C12.6639 12.6179 12.7427 12.8037 12.8693 12.9554C12.9959 13.1071 13.1646 13.2178 13.3541 13.2738C13.5436 13.3297 13.7454 13.3282 13.9341 13.2696C15.4659 12.7894 16.8138 11.8515 17.7964 10.5821C18.3869 11.4544 18.773 12.4487 18.9259 13.4909C19.0787 14.5332 18.9944 15.5965 18.6792 16.6016C18.364 17.6068 17.826 18.5278 17.1054 19.2961C16.3847 20.0644 15.5 20.6602 14.5171 21.0391L14.5171 21.0391Z"/>
                      </svg>
                    </span>
                    Активен
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="row container-shadow fill-white">
          <template v-if="loading && video && module">
            <div class="video-lectures__player" :class="{'col-md-8': !isFullScreen, 'col-md-12 video-lectures__player-fullscreen': isFullScreen}" v-if="playerOptions.sources">
              <div class="video-lectures__player__header row" v-if="!isPlay">
                <div class="video-lectures__player__header__title">
                  Видеолекция {{ module.index }}.{{video.index}} {{ video.title }}
                </div>
              </div>
              <div @click="setFullScreen" class="video-lectures__player__fullscreen"></div>
              <video-player class="video-lectures__player-box"
                            ref="videoPlayer"
                            :options="playerOptions"
                            :playsinline="true"
                            customEventName="customstatechangedeventname"
                            @timeupdate="onPlayerTimeupdate"
                            @play="onPlayerPlay($event)"
                            @pause="onPlayerPause($event)">
              </video-player>
            </div>
            <div class="col-md-4 video-lectures__module p-24" v-if="!isFullScreen">
              <div class="video-lectures__module-title">
                {{ module.title }}
              </div>
              <div class="video-lectures__video-title">
                Видеолекция {{ module.index }}.{{video.index}} {{ video.title }}
              </div>
              <div class="video-lectures__video-description">
                <ul class="nav nav-tabs nav-tabs_bordered mb-5" id="myTab2" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="basic-tab" data-toggle="tab" href="#basic" role="tab" aria-controls="basic"
                       aria-selected="true">Описание <span></span></a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" id="acceleration-tab" data-toggle="tab" href="#acceleration" role="tab" aria-controls="acceleration"
                       aria-selected="false">Видеолекции  <span></span></a>
                  </li>
                </ul>
                <div class="tab-content video-lectures__video-description__list" id="myTabContent2">
                  <div class="tab-pane fade show active" id="basic" role="tabpanel" aria-labelledby="basic-tab">
                    <div class="fill-grey p-24" v-html="video.description"></div>
                    <template v-if="attaches">
                      <document-gray class="mt-24" v-for="attach in attaches.attachments" :key="attach.id" :title="attach.name" :link="attach.file" />
                    </template>
                    <div class="mt-24">
                      <router-link class="section__lk-content-item-data-title" to="/lk/online">
                        К общему списку модулей курса <img src="/pic/profile/arrow-up-right-red.svg" />
                      </router-link>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="acceleration" role="tabpanel" aria-labelledby="acceleration-tab">
                    <ul class="list list_dotted">
                      <li v-for="(video, key) in videos" :key="key">
                        <router-link class="video-title" :to="`/course/${$route.params.course}/module/${$route.params.module}/lecture/${video.index}`">
                          <span v-if="video.snapshot_about" class="tooltip-video" :style="{background:  'url(/pic/arrow-up-right.svg) center center no-repeat, url(' + video.snapshot_about['1280x720'] + ') center center no-repeat' }"></span>
                          {{ video.title }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <page-footer />
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import PageFooter from "@/components/PageFooter.vue";
import DocumentGray from "@/components/DocumentGray.vue";
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import '../assets/style/video.scss';

export default {
  name: "Video",
  components: {DocumentGray, PageFooter, videoPlayer},
  data() {
    return {
      attaches: null,
      course: null,
      module: null,
      modules: null,
      videos: null,
      loading: false,
      video: false,
      playerOptions: {},
      isFullScreen: false,
      isPlay: false,
      watchCount: 0
    }
  },
  async mounted() {
    this.course = (await ApiService.get(`/courses/${this.$route.params.course}`)).data
    this.attaches = (await ApiService.get(`/courses/${this.$route.params.course}/attaches`)).data
    this.modules = this.course.modules
    this.module = this.modules[this.$route.params.module - 1]
    await this.load()
    this.loading = true
  },
  methods: {
    async onPlayerTimeupdate(player) {
      const time = player.currentTime()
      if(time > 19 && time <= 20) {
        await ApiService.put('/uservideofragments/' + this.video.id, {})
      }
    },
    async load() {
      this.isPlay = false
      this.$nextTick(async () => {
        this.videos = (await ApiService.get(`/courses/${this.$route.params.course}/modules/${this.$route.params.module}/videos`)).data
        this.video = (await ApiService.get(`/courses/${this.$route.params.course}/modules/${this.$route.params.module}/videos/${this.$route.params.lecture}`)).data
        const source = this.getVideoSource(this.video)

        if(!source) {
          this.playerOptions = {}
          return
        }

        this.playerOptions = {
          language: 'ru',
          //playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            src: source.file
          }],
          poster: this.video.snapshot_about ? this.video.snapshot_about['1280x720'] : this.video.cdn_snapshot,
        }
      })

    },
    getVideoSource(video) {
      if(!video || !Array.isArray(video.formats)) {
        return null
      }

      return video.formats.find(format => {
        return format.resolution === '720p' && format.format === 'mp4' && format.file
      }) || video.formats.find(format => {
        return format.format === 'mp4' && format.file
      }) || null
    },
    async getFirstLectureIndex(moduleIndex) {
      const videos = (await ApiService.get(`/courses/${this.$route.params.course}/modules/${moduleIndex}/videos`)).data
      const firstVideo = Array.isArray(videos) ? videos[0] : null

      return firstVideo && firstVideo.index ? firstVideo.index : null
    },
    // listen event
    onPlayerPlay() {
       this.isPlay = true
    },
    onPlayerPause() {
      this.isPlay = false
    },
    setFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    }
  },
  watch: {
    async module(val) {
      if(val) {
        if(Number(val.index) === Number(this.$route.params.module)) {
          return
        }

        const lectureIndex = await this.getFirstLectureIndex(val.index)

        if(lectureIndex) {
          this.$router.push(`/course/${this.$route.params.course}/module/${val.index}/lecture/${lectureIndex}`).catch(() => {})
        } else {
          this.videos = []
          this.video = false
          this.playerOptions = {}
        }
      }
    },
    '$route.path': {
      handler: async function() {
        await this.load()
      }
    }
  }
}
</script>
